import * as Yup from 'yup'

const sellerIdentityProofFormSchema = () => (
  Yup.object().shape({
    identity_type: Yup.string()
      .required('Required'),
    identity_proof_image: Yup.array()
      .min(1, 'Required')
  })
)

export default sellerIdentityProofFormSchema
